module.exports = __webpack_public_path__ + "static/media/thanks.bf5aa71e.png";